/** Carrega módulos Magon somente quando o componente existe na página. */
const configElement = document.querySelector('[data-magon-lazy-modules]');
let entries = [];

try {
  entries = JSON.parse(configElement?.textContent || '[]');
} catch (_) {
  entries = [];
}

const loaded = new Set();

function loadPresentModules(root = document) {
  for (const entry of entries) {
    if (!entry?.selector || !entry?.src || loaded.has(entry.src)) continue;
    const present = root.matches?.(entry.selector) || root.querySelector?.(entry.selector);
    if (!present) continue;
    loaded.add(entry.src);
    import(entry.src).catch(() => loaded.delete(entry.src));
  }
}

loadPresentModules();

document.addEventListener('shopify:section:load', (event) => {
  loadPresentModules(event.target);
});
